import { useContext } from "react";
import { InvestTransactionContext } from "./contexts/InvestTransactionContext";
import { Stack,Typography } from "@mui/material";
import CustomIcon from "../../../../components/customIcon";

export const NoteComponent = () => {
    const { transaction } = useContext(InvestTransactionContext);
    return (
        <Stack direction={"row"} spacing={"10px"}>
            <CustomIcon name="important" sx={{ width: 32, bgcolor: "primary.main", mt: 0.5 }} />
            {
                transaction ?
                    <Typography variant="body3" sx={{ fontWeight: 300, lineHeight: 1.3 }}>
                        After you've made the transfer in the given bank account, click on the Below button to initiate verification and transfer of frax.
                    </Typography>
                    :
                    <Typography variant="body3" sx={{ fontWeight: 300, lineHeight: 1.3 }}>
                        Please complete the Bank Transfer and Confirm the Transaction here within <span style={{ fontWeight: 600, fontStyle: "italic" }}>72 hours</span> to hold the allotment.
                    </Typography>
            }
        </Stack>
    )
}